/* global Swiper */
document.querySelectorAll( '.b-hero-slider' ).forEach( ( block ) => {

	const blockSwiper = block.querySelector( '.b-hero-slider__swiper' );

	new Swiper( blockSwiper, {
		slidesPerView: 1,
		slideClass: 'b-hero-slider-single',
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		on: {
			/**
			 * Add animation on slide change
			 */
			slideChange: function handleSlideChange () {

				if ( window.innerWidth > 768 ) {

					this.slides.forEach( ( slide ) => {

						const imageBlock = slide.querySelector( '.wp-block-image img' );
						imageBlock.style.transform = 'scale(1.3)';

					} );

					const activeSlide = this.slides[ this.activeIndex ];
					const activeImageBlock = activeSlide.querySelector( '.wp-block-image img' );
					activeImageBlock.style.transform = 'scale(1)';

					void activeImageBlock.offsetWidth;

				}

			},
		},
	} );

	const imageBlock = block.querySelector( '.wp-block-image img' );
	imageBlock.style.transform = 'scale(1)';

} );
